/* src/app/components/payroll/purchase-request/purchase-request-participant-view/purchase-request-participant-view.component.css */
.message {
  margin-bottom: 0px;
  margin-top: 0px;
  margin-left: 8px;
  font-weight: 500;
}
::ng-deep ppl-purchase-request-participant-view .purchase-request-filters nz-form-item.ant-form-item {
  margin-bottom: 0;
}
/*# sourceMappingURL=purchase-request-participant-view.component-2GP5K274.css.map */
